import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '📱',
      title: 'Social Media Management',
      description: 'Strategisches Management deiner Social Media Kanäle – von Instagram über TikTok bis LinkedIn. Ich übernehme die komplette Betreuung, damit du dich auf dein Business konzentrieren kannst.',
      features: [
        'Strategische Content-Planung',
        'Community Management',
        'Profile-Optimierung',
        'Regelmäßiges Reporting'
      ]
    },
    {
      icon: '🎨',
      title: 'Content Creation',
      description: 'Hochwertige Inhalte, die deine Marke wirklich zum Strahlen bringen. Von visuell starken Reels über professionelle Carousel-Posts bis hin zu emotionalen Stories.',
      features: [
        'Reels & Kurzvideo-Produktion',
        'Foto-Content & Bildbearbeitung',
        'Story-Content & Templates',
        'Markenkonforme Gestaltung'
      ]
    },
    {
      icon: '🚀',
      title: 'Paid Advertising',
      description: 'Performance-orientierte Werbeanzeigen auf Meta, TikTok und Co. Datenbasiert, strategisch und auf messbare Ergebnisse ausgerichtet.',
      features: [
        'Meta Ads (Instagram & Facebook)',
        'TikTok Ads & Creator Marketing',
        'Funnel-Optimierung',
        'A/B-Testing & Scaling'
      ]
    },
    {
      icon: '🎯',
      title: 'Marketing Strategy',
      description: 'Die strategische Basis für nachhaltigen Erfolg. Positionierung, Zielgruppendefinition und individueller Marketing-Plan – maßgeschneidert für dein Business.',
      features: [
        'Markenpositionierung',
        'Zielgruppen-Analyse',
        'Content-Strategie',
        'Wachstums-Roadmap'
      ]
    },
    {
      icon: '✨',
      title: 'Personal Branding',
      description: 'Werde zur Marke. Aufbau deiner persönlichen Brand auf Social Media – authentisch, professionell und mit Wirkung.',
      features: [
        'Brand-Identity Entwicklung',
        'Personal Storytelling',
        'Content-Säulen Definition',
        'Authority Building'
      ]
    },
    {
      icon: '📊',
      title: 'Consulting & Workshops',
      description: 'Du möchtest selbst Hand anlegen, brauchst aber strategischen Input? In individuellen Consultings und Workshops teile ich mein Wissen mit dir und deinem Team.',
      features: [
        '1:1 Strategie-Sessions',
        'Team-Workshops',
        'Audit & Analyse',
        'Schulungen & Trainings'
      ]
    }
  ];

  return (
    <div className="services-page">
      {/* Hero */}
      <section className="services-hero">
        <div className="services-hero-bg"></div>
        <div className="services-hero-content">
          <span className="section-label">Leistungen</span>
          <h1 className="services-hero-title">
            Mein Angebot für<br />
            <span className="gold">deinen Erfolg</span>
          </h1>
          <p className="services-hero-subtitle">
            Von strategischer Beratung bis zur kompletten Umsetzung – ich biete dir 
            alles, was du für nachhaltige Sichtbarkeit und Wachstum auf Social Media brauchst.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-grid-section">
        <div className="section-container">
          <div className="services-list">
            {services.map((service, index) => (
              <div key={index} className="service-detail-card">
                <div className="service-card-header">
                  <span className="service-icon">{service.icon}</span>
                  <h2 className="service-title">{service.title}</h2>
                </div>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, i) => (
                    <li key={i}>
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="services-process">
        <div className="section-container">
          <div className="section-header">
            <span className="section-label">So arbeiten wir zusammen</span>
            <h2 className="section-title">In 4 Schritten zu deinem Erfolg</h2>
          </div>

          <div className="process-flow">
            <div className="flow-step">
              <div className="flow-number">1</div>
              <h3>Kennenlernen</h3>
              <p>Kostenloses Erstgespräch – wir besprechen deine Ziele und Möglichkeiten</p>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="flow-number">2</div>
              <h3>Strategie</h3>
              <p>Entwicklung einer maßgeschneiderten Strategie für dein Business</p>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="flow-number">3</div>
              <h3>Umsetzung</h3>
              <p>Professionelle Umsetzung deiner Marketing-Maßnahmen</p>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="flow-number">4</div>
              <h3>Wachstum</h3>
              <p>Kontinuierliche Optimierung und nachhaltiges Wachstum</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="services-cta">
        <div className="section-container">
          <div className="services-cta-content">
            <h2>Bereit für den nächsten Schritt?</h2>
            <p>Entdecke meine Pakete und finde das passende Angebot für dein Business.</p>
            <div className="cta-buttons">
              <Link to="/preise" className="btn-primary">
                Preise ansehen
                <span className="btn-arrow">→</span>
              </Link>
              <Link to="/kontakt" className="btn-secondary">
                Kostenloses Erstgespräch
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
